import { jsx as _jsx } from "react/jsx-runtime";
import CheckBox from "@mui/material/Checkbox";
const darkModeStyles = {
    color: "#fff",
    position: "relative",
    zIndex: 0,
    "&::after": {
        content: '""',
        left: 14,
        top: 14,
        height: 15,
        width: 15,
        position: "absolute",
        backgroundColor: "#fff",
        zIndex: -1,
    },
};
export const BaseCheckboxInput = ({ dataTestId = "", mode, ...props }) => {
    const inputProps = { "data-testid": dataTestId };
    return _jsx(CheckBox, { ...props, color: "primary", inputProps: inputProps, sx: mode === "dark" ? darkModeStyles : {} });
};
//# sourceMappingURL=BaseCheckboxInput.js.map